
const ALTIMETER_ONLY_DATA_FIELDS = [
  'furtherCreditName',
  'recipientName',
  'recipientAddress',
  'accountAddress',
  'furtherCreditNumber',
  'furtherCreditAddress',
  'intermediarySwiftBIC',
  'beneficiaryBank',
  'beneficiarySwiftBIC',
  'ibanNumber',
  'furtherCreditAccountNumber',
  'existingAltimeter8a',
  'existingAltimeter8b',
  'existingAltimeter8c',
  'existingAltimeter8d',
];

const ALTIMETER_ONLY_HEADERS = [
  'Recipient Name',
  'Recipient Address',
  'Account Address',
  'For Further Credit to Name',
  'For Further Credit to Account #',
  'For Further Credit to Address',
  'Intermediary Bank Swift/BIC',
  'Beneficiary Bank',
  'Beneficiary Bank Swift/BIC',
  'IBAN Number',
  'Existing Altimeter 8(a)',
  'Existing Altimeter 8(b)',
  'Existing Altimeter 8(c)',
  'Existing Altimeter 8(d)',
];

const PICTURE_CAPITAL_DATA_FIELDS = [
  'israeliTaxStatus1',
  'israeliTaxStatus2',
  'israeliTaxStatus3',
  'israeliTaxStatus4',
  'israeliTaxStatus5',
  'israeliTaxStatus6',
  'israeliTaxStatus7',
  'israeliTaxStatus7a',
  'israeliTaxStatus7b',
  'israeliTaxStatus7PctNonIsraeli',
  'israeliTaxStatus7PctExempt',
  'israeliTaxStatus7PctNonExempt',
  'israeliTaxStatus8',
  'israeliTaxStatus9',
  'israeliTaxStatus10',
  'israeliTaxStatus11',
  'israeliTaxStatus11a',
  'israeliTaxStatus11b',
  'israeliTaxStatus11c',
];

const ADDITIONAL_CONTACT_DATA_FIELDS = [
  'additionalContactName1',
  'additionalContactEmail1',
  'additionalContactNotices1',
  'additionalContactName2',
  'additionalContactEmail2',
  'additionalContactNotices2',
  'additionalContactName3',
  'additionalContactEmail3',
  'additionalContactNotices3',
];

const ADDITIONAL_CONTACT_HEADERS = [
  'ContactName1',
  'Email1',
  'Notices1',
  'ContactName2',
  'Email2',
  'Notices2',
  'ContactName3',
  'Email3',
  'Notices3',
];

const BENCHMARK_ADDITIONAL_CONTACT_DATA_FIELDS = [
  'partnerStatementsPrimaryContactName',
  'partnerStatementsPrimaryContactEmail',
  'partnerStatementsPrimaryContactPhone',
  'partnerStatementsSecondaryContactName',
  'partnerStatementsSecondaryContactEmail',
  'partnerStatementsSecondaryContactPhone',
  'reportsPrimaryContactName',
  'reportsPrimaryContactEmail',
  'reportsPrimaryContactPhone',
  'reportsSecondaryContactName',
  'reportsSecondaryContactEmail',
  'reportsSecondaryContactPhone',
  'taxPrimaryContactName',
  'taxPrimaryContactEmail',
  'taxPrimaryContactPhone',
  'taxSecondaryContactName',
  'taxSecondaryContactEmail',
  'taxSecondaryContactPhone',
  'capitalPrimaryContactName',
  'capitalPrimaryContactEmail',
  'capitalPrimaryContactPhone',
  'capitalSecondaryContactName',
  'capitalSecondaryContactEmail',
  'capitalSecondaryContactPhone',
  'stockPrimaryContactName',
  'stockPrimaryContactEmail',
  'stockPrimaryContactPhone',
  'stockSecondaryContactName',
  'stockSecondaryContactEmail',
  'stockSecondaryContactPhone',
  'legalPrimaryContactName',
  'legalPrimaryContactEmail',
  'legalPrimaryContactPhone',
  'legalSecondaryContactName',
  'legalSecondaryContactEmail',
  'legalSecondaryContactPhone',
];

export const EXCLUDE_DATA = {
  ADDITIONAL_CONTACTS: ADDITIONAL_CONTACT_DATA_FIELDS,
  BENCHMARK_ADDITIONAL_CONTACTS: BENCHMARK_ADDITIONAL_CONTACT_DATA_FIELDS,
  WIREINSTRUCTIONS_EXCLUDED:  [
    'bankName',
    'acctName',
    'swiftCode',
    'acctNumber',
    'bankaba',
    'furtherCredit',
    'recipientName',
    'recipientAddress',
    'accountAddress',
    'furtherCreditNumber',
    'furtherCreditAddress',
    'intermediarySwiftBIC',
    'beneficiaryBank',
    'beneficiarySwiftBIC',
    'ibanNumber',
  ],
  LIMITED_PARTNER: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
    'disregardedEntity',
  ],
  SINGLE_PICTURE_CAPITAL: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...ALTIMETER_ONLY_DATA_FIELDS,
    'disregardedEntity',
  ],
  BENCHMARK: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  ALTIMETER: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    'disregardedEntity',
  ],
  ALTIMETER_PREMIER_GROWTH: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    'disregardedEntity',
    'Existing Altimeter 8(a)',
    'Existing Altimeter 8(b)',
    'Existing Altimeter 8(c)',
    'Existing Altimeter 8(d)',
  ],
  ALTIMETER_AML: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    'disregardedEntity',
  ],
  UNION_PEAK: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  SORENSON: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'bhcaPartner',
    'bankName',
    'acctName',
    'swiftCode',
    'acctNumber',
    'bankaba',
    'furtherCredit',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  VARIANT: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'usPersonIrcb',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  BITKRAFT_INDIA: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  FRAZIER: [
     'foresite_investor_type',
     'capitalCommitted',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
   
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  SR_ONE: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  CAYMAN: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  AUDERE: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  LIMITED_LIABILITY_COMPANY: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  FORESITE: [
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  QUESTACAPITAL: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  INITIALIZED: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  HCM: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'institutionalAccountStatus',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  FORESITELABS: [
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'foresite_investor_type',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  LIMITED_PARTNER_ABBR: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  IOLAR: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  OSAGE: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  NEW_LIMITED_PARTNER: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
   TCG_CROSSOVER: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  TCG_CROSSOVER_CAYMAN: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
   BITKRAFT: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  ELEPHANT_PARTNER: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  FIREWORK: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
   PROMETHEAN: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  ACCEL: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  ACCELMAIN: [
    'beneficialOwner',
    'usBeneficial',
    'taxedPartnership',
    'taxedAsPartnership',
    'usBeneficialOwners',
    'exemptedEntityStatus',
    'look_c',
    'look_d',
    'look_e',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  ACCEL_ENTREPRENEURS: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  ACCEL_CIRCLE: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  CUSTOM_ADDITIONAL_CONTACTS: [
    'reportsPrimaryContactName',
    'reportsPrimaryContactEmail',
    'reportsPrimaryContactPhone',
    'reportsSecondaryContactName',
    'reportsSecondaryContactEmail',
    'reportsSecondaryContactPhone',
    'taxPrimaryContactName',
    'taxPrimaryContactEmail',
    'taxPrimaryContactPhone',
    'taxSecondaryContactName',
    'taxSecondaryContactEmail',
    'taxSecondaryContactPhone',
    'capitalPrimaryContactName',
    'capitalPrimaryContactEmail',
    'capitalPrimaryContactPhone',
    'capitalSecondaryContactName',
    'capitalSecondaryContactEmail',
    'capitalSecondaryContactPhone',
    'stockPrimaryContactName',
    'stockPrimaryContactEmail',
    'stockPrimaryContactPhone',
    'stockSecondaryContactName',
    'stockSecondaryContactEmail',
    'stockSecondaryContactPhone',
    'legalPrimaryContactName',
    'legalPrimaryContactEmail',
    'legalPrimaryContactPhone',
    'legalSecondaryContactName',
    'legalSecondaryContactEmail',
    'legalSecondaryContactPhone',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'bankName',
    'acctName',
    'swiftCode',
    'acctNumber',
    'bankaba',
    'furtherCredit',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'disregardedEntity',  
  ],
  ACCEL_ENTREPRENEURS_RETURNING: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'contactPersonPhone',
    'location',
    'wireInfo',
    'naturalPerson',
    'usPersonSecAct',
    'usPersonIrc',
    'finra',
    'foia_a',
    'foia_b',
    'foia_c',
    'foia_d',
    'foia_e',
    'foia_f',
    'badActor',
    'accreditedInvestor',
    'qualifiedPurchaser',
    'qualifiedClient',
    'fatfCountry',
    'country',
    'bankLocation',
    'wiringBankCustomer',
    'erisa_a',
    'erisa_b',
    'plannedAssetsPerc',
    'look_a',
    'look_b',
    'look_c',
    'look_d',
    'look_e',
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'fundOfFunds',
    'taxExempt',
    'taxedAsPartnership',
    'taxExemptOwners',
    'escrow',
    'reportsPrimaryContactName',
    'reportsPrimaryContactEmail',
    'reportsPrimaryContactPhone',
    'reportsSecondaryContactName',
    'reportsSecondaryContactEmail',
    'reportsSecondaryContactPhone',
    'taxPrimaryContactName',
    'taxPrimaryContactEmail',
    'taxPrimaryContactPhone',
    'taxSecondaryContactName',
    'taxSecondaryContactEmail',
    'taxSecondaryContactPhone',
    'capitalPrimaryContactName',
    'capitalPrimaryContactEmail',
    'capitalPrimaryContactPhone',
    'capitalSecondaryContactName',
    'capitalSecondaryContactEmail',
    'capitalSecondaryContactPhone',
    'stockPrimaryContactName',
    'stockPrimaryContactEmail',
    'stockPrimaryContactPhone',
    'stockSecondaryContactName',
    'stockSecondaryContactEmail',
    'stockSecondaryContactPhone',
    'legalPrimaryContactName',
    'legalPrimaryContactEmail',
    'legalPrimaryContactPhone',
    'legalSecondaryContactName',
    'legalSecondaryContactEmail',
    'legalSecondaryContactPhone',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'bankName',
    'acctName',
    'swiftCode',
    'acctNumber',
    'bankaba',
    'furtherCredit',
    'cfiusForeignPerson',
    'institutionalAccountStatus',
    'exemptedEntityStatus',
    'usBeneficialOwners',
    'foreignGovtControlled',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB', 
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  LIMITED_PARTNER_MULTI_FUND: [
    'governmentEntity',
    'bhcaPartner',
    'foundationPartner',
    'publicPensionPartner',
    'wiringBankCustomer',
    'country',
    'fatfCountry',
    'wireInfo',
    'usPersonSecAct',
    'badActor',
    'finraAffiliation',
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'finra',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  LIMITED_PARTNERSHIP_MULTI_FUND: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,   
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  BENCHMARK_MULTI_FUND: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    ...PICTURE_CAPITAL_DATA_FIELDS,   
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  PICTURE_CAPITAL_MULTI_FUND: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  NICFUND: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  TERRARIUM: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  DCVC: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'accreditedInvestorRep2',
    'accreditedInvestorRep3',
    'accreditedInvestorRep4',
    'accreditedInvestorRep5',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
  OCM: [
    'foresite_investor_type',
    'foresiteFinraAffiliation',
    'foresiteFinraAffiliationFurtherDetails',
    'foresitePublicCompanyAffiliation',
    'foresitePublicCompanyAffiliationFurtherDetails',
    'foresiteEntities',
    'foresiteEntitiesFurtherDetails',
    'hcm',
    'institutionalAccountStatus',
    'partnerStatementsPrimaryContactName',
    'partnerStatementsPrimaryContactEmail',
    'partnerStatementsPrimaryContactPhone',
    'partnerStatementsSecondaryContactName',
    'partnerStatementsSecondaryContactEmail',
    'partnerStatementsSecondaryContactPhone',
    'rule5130_finraNewIssues_1',
    'rule5130_finraNewIssues_2',
    'rule5131_finraNewIssues_1',
    'rule5131_finraNewIssues_2',
    'retirementPlan',
    'foreignPartner',
    'Rep7EUandUK',
    'Rep8Switzerland',
    'totalAllFund',
    'PartAFinra',
    'PartBFinra',
    'subscription',
    'indiaTaxPurposes',
    'sharesLandBorder',
    'nationality',
    'previouslySubscribed',
    'distributionElectionIKUs',
    'usPersonIrcb',
    'flowThroughtEntityIncomeTax',
    'bhcaPartnerA',
    'bhcaPartnerB',
    'identityPrimaryContactName',
    'identityPrimaryContactEmail',
    'identityPrimaryContactPhone',
    'identitySecondaryContactName',
    'identitySecondaryContactEmail',
    'identitySecondaryContactPhone',
    'disregardedEntity',  
    ...PICTURE_CAPITAL_DATA_FIELDS,
    ...ALTIMETER_ONLY_DATA_FIELDS,
  ],
};

const PICTURE_CAPITAL_HEADERS = [
  'Israeli Tax Status 1',
  'Israeli Tax Status 2',
  'Israeli Tax Status 3',
  'Israeli Tax Status 4',
  'Israeli Tax Status 5',
  'Israeli Tax Status 6',
  'Israeli Tax Status 7',
  'Israeli Tax Status 7(a)',
  'Israeli Tax Status 7(b)',
  'Israeli tax 7 (a) Non-Israeli residents',
  'Israeli tax 7 (b) Israeli exempt investors',
  'Israeli tax 7 (c) Israeli non-exempt investors',
  'Israeli Tax Status 8',
  'Israeli Tax Status 9',
  'Israeli Tax Status 10',
  'Israeli Tax Status 11',
  'Israeli tax 11 (a) Nostro',
  'Israeli tax 11 (b) Gemel / Hishtalmut',
  'Israeli tax 11 (c) Mishtatfot',
];

export const EXCLUDE_HEADERS = {
  ADDITIONAL_CONTACTS: ADDITIONAL_CONTACT_HEADERS,
  WIREINSTRUCTIONS_EXCLUDED: [
    'For Further Credit to',
    'Bank ABA#',
    'Account Number',
    'Swift Code',
    'Accountholder Name',
    'Bank Name',
    'City/State/Country',
  ],
  CUSTOM_ADDITIONAL_CONTACTS: [
    'Phone Number',
    'Email Address',
    'Phone Number',
    'Email Address',
    'Phone Number',
    'Email Address',
    'Phone Number',
    'Email Address',
    'Phone Number',
    'For Further Credit to',
    'Bank ABA#',
    'Account Number',
    'Swift Code',
    'Accountholder Name',
    'Bank Name',
    'Legal Documents Secondary Contact Name',
    'Legal Documents Primary Contact Name',
    'AML/KYC Requests Secondary Contact Name',
    'AML/KYC Requests Primary Contact Name',
    'Cash and Stock Distributions Secondary Contact Name',
    'Cash and Stock Distributions Primary Contact Name',
    'Capital Call Notices Secondary Contact Name',
    'Capital Call Notices Primary Contact Name',
    'Tax Information/K-1s Secondary Contact Name',
    'Tax Information/K-1s Primary Contact Name',
    `Quarterly Partner's Capital Statements Secondary Contact Name`,
    `Quarterly Partner's Capital Statements Primary Contact Name`,
    'Quarterly and Annual Reports Secondary Contact Name',
    'Quarterly and Annual Reports Primary Contact Name',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
  ],
  LIMITED_PARTNER: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  SINGLE_PICTURE_CAPITAL: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Notes to Client',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...ALTIMETER_ONLY_HEADERS,
  ],
  BENCHMARK: [
     'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  ALTIMETER: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
  ],
  ALTIMETER_PREMIER_GROWTH: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    'Existing Altimeter 8(a)',
    'Existing Altimeter 8(b)',
    'Existing Altimeter 8(c)',
    'Existing Altimeter 8(d)',
    ...PICTURE_CAPITAL_HEADERS,
  ],
  ALTIMETER_AML: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
  ],
  UNION_PEAK: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  SORENSON: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'For Further Credit to',
    'Bank ABA#',
    'Account Number',
    'Swift Code',
    'Accountholder Name',
    'Bank Name',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  VARIANT: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  BITKRAFT_INDIA: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   FRAZIER: [
    'Capital Committed',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  SR_ONE: [
   'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  CAYMAN: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   AUDERE: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  LIMITED_LIABILITY_COMPANY: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  FORESITE: [
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  QUESTACAPITAL: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  INITIALIZED: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  HCM: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  FORESITELABS: [
    'Foresite Investor Type',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  LIMITED_PARTNER_ABBR: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',  
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   IOLAR: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
    'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  OSAGE: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  NEW_LIMITED_PARTNER: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   TCG_CROSSOVER: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  TCG_CROSSOVER_CAYMAN: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  BITKRAFT: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   ELEPHANT_PARTNER: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',  
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   FIREWORK: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  PROMETHEAN: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   ACCEL: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  ACCELMAIN: [
    'Taxed as a Partnership',
    '100% U.S. Beneficial Owners',
    'Tax Exempt Beneficial Owners',
    'Lookthrough (c)',
    'Lookthrough (d)',
    'Lookthrough (e)',
     'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  ACCEL_ENTREPRENEURS: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  ACCEL_CIRCLE: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  ACCEL_ENTREPRENEURS_RETURNING: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Total All Funds',
    'City/State/Country',
    'For Further Credit to',
    'Bank ABA#',
    'Account Number',
    'Swift Code',
    'Accountholder Name',
    'Bank Name',
    'Phone Number',
    'Email Address',
    'Legal Documents Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Phone Number',
    'Email Address',
    'Legal Documents Primary Contact Name',
    'Phone Number',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Cash and Stock Distributions Secondary Contact Name',
    'Cash and Stock Distributions Primary Contact Name',
    'Capital Call Notices Secondary Contact Name',
    'Capital Call Notices Primary Contact Name',
    'Tax Information/K-1s Secondary Contact Name',
    'Tax Information/K-1s Primary Contact Name',
    `Quarterly Partner's Capital Statements Secondary Contact Name`,
    `Quarterly Partner's Capital Statements Primary Contact Name`,
    'Quarterly and Annual Reports Secondary Contact Name',
    'Quarterly and Annual Reports Primary Contact Name',
    'Exceptions',
    'Escrow',
    'Tax Exempt Beneficial Owners',
    '100% U.S. Beneficial Owners',
    'Taxed as a Partnership',
    'Tax Exempt',
    'Fund-of-Funds?',
    'Lookthrough (e)',
    'Lookthrough (d)',
    'Lookthrough (c)',
    'Lookthrough (b)',
    'Lookthrough (a)',
    '% of Plan Assets',
    'ERISA(b)',
    'ERISA(a)',
    'Qualified Client?',
    'Qualified Purchaser?',
    'Accredited Investor?',
    'FOIA(f)',
    'FOIA(e)',
    'FOIA(d)',
    'FOIA(c)',
    'FOIA(b)',
    'FOIA(a)',
    'US Person (IRC)?',
    'Natural Person',
    'Place of Residence/Business',
    'CFIUS Foreign Person',
    'Foreign Govt Controlled',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  LIMITED_PARTNER_MULTI_FUND: [
    'Government Entity?',
    'BHCA Partner?',
    'Foundation Partner?',
    'Public Pension Partner?',
    'Customer of Wiring Bank?',
    'If no, Country?',
    'FATF Country',
    'Wire Info?',
    'US Person (SEC Act)?',
    'Bad Actor?',
    'FINRA',
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  LIMITED_PARTNERSHIP_MULTI_FUND: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
    'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  BENCHMARK_MULTI_FUND: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Contact Person Address',
    'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  PICTURE_CAPITAL_MULTI_FUND: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
    'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
     ...ALTIMETER_ONLY_HEADERS,
  ],
  NICFUND: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
    'Contact Person Address',
    'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    'Total All Funds',
    'Subscription',
    'Previously subscribed?',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  TERRARIUM: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
   DCVC: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Accredited Investor 2',
    'Accredited Investor 3',
    'Accredited Investor 4',
    'Accredited Investor 5',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',  
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
  OCM: [
    'Foresite Investor Type',
    'Foresite FINRA Affiliation',
    'Foresite FINRA Affiliation Further Details',
    'Foresite Public Company Affiliation',
    'Foresite Public Company Affiliation Further Details',
    'Foresite Entities',
    'Foresite Entities Further Details',
    'Institutional Account Status',
    'Finra Rule 5130 1',
    'Finra Rule 5130 2',
    'Finra Rule 5131 1',
    'Finra Rule 5131 2',
    'Returning Investor',
    'Total All Funds',
     'Part A: FINRA Rule 5130',
    'Part B: FINRA Rule 5131',
    'Subscription',
    'India tax purposes',
    'Shares land border with India?',
    'Nationality',
    'Previously subscribed?',
    'Investor wishes to receive in-kind distributions of IKUs',
    'Non-U.S Partner Status (IRC) (b)?',
    'BHCA Partner (b)',
    'AML/KYC Requests Primary Contact Name',
    'Phone Number',
    'Email Address',
    'AML/KYC Requests Secondary Contact Name',
    'Phone Number',
    'Email Address',
    'Disregarded Entity',
    ...PICTURE_CAPITAL_HEADERS,
    ...ALTIMETER_ONLY_HEADERS,
  ],
};

// using "filteringId"
// move is the field that will be move and after where it will be moves
export const MOVE_HEADERS = {
  LIMITED_PARTNER: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  SINGLE_PICTURE_CAPITAL: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  BENCHMARK: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  ALTIMETER: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  ALTIMETER_PREMIER_GROWTH: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  ALTIMETER_AML: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  UNION_PEAK: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  SORENSON: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  VARIANT: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  TERRARIUM: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  DCVC: [
   { move: 'investment-notes-col', after: 'investment-ofac-col' },
   { move: 'cfiusForeignPerson-col', after: 'location-col' },
   { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  OCM: [
   { move: 'investment-notes-col', after: 'investment-ofac-col' },
   { move: 'cfiusForeignPerson-col', after: 'location-col' },
   { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  BITKRAFT_INDIA: [
   { move: 'investment-notes-col', after: 'investment-ofac-col' },
   { move: 'cfiusForeignPerson-col', after: 'location-col' },
   { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
  FRAZIER: [
    { move: 'investment-notes-col', after: 'investment-ofac-col' },
    { move: 'cfiusForeignPerson-col', after: 'location-col' },
    { move: 'foreignGovtControlled-col', after: 'cfiusForeignPerson-col' },
  ],
};
